import { motion, useReducedMotion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next";
import { CalendarClock } from "lucide-react";

export function LandingHero() {
  const { t } = useTranslation();
  const prefersReducedMotion = useReducedMotion();

  // LCP optimisation: the eyebrow + H1 render immediately (no opacity/y animation)
  // so Largest Contentful Paint happens on first frame. Only the subheadline
  // fades in for a subtle motion cue.
  const subVariants: Variants = {
    hidden: { opacity: 0, y: prefersReducedMotion ? 0 : 12 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, delay: prefersReducedMotion ? 0 : 0.15 },
    },
  };

  const eyebrow = t("landing.heroEyebrow", "Exams are coming. Time to revise.");
  const headlinePart1 = t("landing.heroHeadlinePart1", "Ace your exams with revision sheets built");
  const headlinePart2 = t("landing.heroHeadlinePart2", "from your own courses");
  const subheadline = t(
    "landing.heroSubheadline",
    "ChatGPT doesn't know your professor, your syllabus or your slides. System Atlas does. Upload your courses and get structured revision sheets, quizzes and answers grounded in your material — ready in seconds."
  );

  return (
    <div className="text-center mb-10 relative">
      <div
        className="inline-flex items-center gap-2 mb-5 text-primary text-sm font-semibold"
      >
        <CalendarClock className="w-3.5 h-3.5 shrink-0" />
        <span>{eyebrow}</span>
      </div>
      <h1
        className="text-3xl sm:text-5xl md:text-6xl font-heading font-medium max-w-3xl mx-auto leading-[1.04]"
      >
        <span className="text-foreground">{headlinePart1} </span>
        <span className="text-primary">{headlinePart2}</span>
      </h1>
      <motion.p
        variants={subVariants}
        initial="hidden"
        animate="visible"
        className="mt-4 sm:mt-5 text-sm sm:text-base text-muted-foreground max-w-xl mx-auto leading-relaxed px-2"
      >
        {subheadline}
      </motion.p>
    </div>
  );
}
